module.exports = __webpack_public_path__ + "assets/img/typeIcon-3-blue.0017cd3e.svg";